import styled from 'styled-components';

export const AppBox = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`;

export const SearchBarBox = styled.div`
  display: flex;
  box-shadow: 0px 5px 5px #ccc, 0px -3px 5px #ccc;
  z-index: 2;
`;

export const MainLoading = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HeartButton = styled.div<{ showFavs: boolean }>`
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;  
  cursor: pointer;
  transition: background-color 200ms ease;
  background-color: ${props => props.showFavs ? '#eee' : '#ddd'};
  & i {
    color: #F23C3C;
    transition: opacity 200ms ease;
    opacity: ${props => props.showFavs ? 1 : 0.1};
  }
`;